import React from "react";
import Label from "../label";
import MessageError from "../../message/__errors";
import "../styles.css";
import "./styles.css";

// Файловое поле. value — File|null (страница хранит выбранный файл в state),
// onChange получает нативное событие (файл — e.target.files[0]).
export default function InputFile({ value = null, children, errors, className = '', hasLabel = true, readOnly = false, accept, onChange }) {
    return <>
        {hasLabel ? <Label>{children}</Label> : null}
        <label className={`input input-file ${className}`}>
            <input
                type="file"
                className="input-file__control"
                accept={accept}
                disabled={readOnly}
                onChange={onChange}
            />
            <span className={`input-file__name${value ? '' : ' input-file__name_empty'}`}>
                {value ? `${value.name} (${Math.round(value.size / 1048576)} МБ)` : 'Файл не выбран'}
            </span>
        </label>
        {errors ? <MessageError errors={errors}/> : null}
    </>;
}
